"use client";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useRouter } from "@/i18n/routing";
import { Search } from "lucide-react";
import React, { useEffect, useState } from "react";

type Props = {
  search: string;
  url: string;
  label: string;
  button: string;
};

const BasicResourceInput: React.FC<Props> = ({
  button,
  label,
  url,
  search,
}) => {
  const [currentSearch, setCurrentSearch] = useState(search || "");
  const router = useRouter();

  useEffect(() => {
    setCurrentSearch(search);
  }, [search]);

  const onSearch = () => {
    const params = new URLSearchParams();

    if (currentSearch) {
      params.set("search", currentSearch);
    }

    router.push(`${url}?` + params.toString());
  };

  return (
    <div className="relative">
      <div className="flex flex-col sm:grid grid-cols-[1fr_auto_auto] gap-2">
        <div className="relative w-full">
          <Search className="absolute top-1/2 left-3 transform text-muted-foreground size-5 -translate-y-1/2" />
          <Input
            defaultValue={search}
            onChange={(e) => setCurrentSearch(e.target.value)}
            placeholder={label}
            className="pl-10 text-xs sm:text-sm"
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                onSearch();
              }
            }}
          />
        </div>

        <Button type="button" onClick={onSearch} className="cursor-pointer">
          <span>{button}</span>
        </Button>
      </div>
    </div>
  );
};

export default BasicResourceInput;
